import * as CONSTANTS from '../../constants';
import { post } from '../../utils/apiUtils';

export function getCounterPartReminderList() {
  return post(CONSTANTS.getCounterPartReminderListURL);
}

export function markCounterPartRemindersAsDone(counterPartReminderIds) {
  const payload = {
    counterPartReminderIds
  };
  return post(CONSTANTS.markCounterPartRemindersAsDoneURL, payload);
}

export function deleteCounterPartReminders(counterPartReminderIds) {
  const payload = {
    counterPartReminderIds
  };
  return post(CONSTANTS.deleteCounterPartRemindersURL, payload);
}
